<template>
<layout-content :title="`${editName}管理`">
  <template #toolbar>
    <section class="toolbar-btn">
      <el-button
        :disabled="!org"
        type="orange"
        icon="el-icon-plus"
        size="small"
        @click="onOpenEditor()"
      >新建{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <el-table
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onOpenEditor"
    >
      <el-table-column label="序号" width="50">
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>

      <el-table-column prop="realName" label="姓名" />
      <el-table-column prop="username" label="用户名" />
      <el-table-column prop="mobile" label="联系方式" />
      <el-table-column prop="email" label="邮箱" />

      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="{row}">
          <div class="table-operator-wrapper">
            <span class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">
              <i class="el-icon-delete" aria-hidden="true"></i>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </template>

  <template #editor>
    <user-editor
      ref="editor"
      :org="org"
      :org-id="org ? org.id : '0'"
      :max-audit-stage="maxAuditStage"
      :org-site-devices="orgSiteDevices"
      @save="getList"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../BaseListEditor'
import {ORG_SELECT_CHANGED} from './EventKeys'
import UserEditor from './UserEditor'

export default {
  name: 'UserListEditor',
  extends: BaseListEditor,
  components: {UserEditor},
  props: {
    orgSiteDevices: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      org: null,
      maxAuditStage: 0
    }
  },
  computed: {
    apiKey () {
      return 'User'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return '用户'
    }
  },
  methods: {
    onOrgSelectChanged (org) {
      let {id: orgId} = org

      if (!orgId) {
        this.org = null
        this.list = []
        return
      }

      org = this.org = Object.freeze(JSON.parse(JSON.stringify(org)))
      this.query.orgId = orgId
      this.getList()
    }
  },
  created () {
    this.$api.User.getMaxAuditStage().then(maxAuditStage => {
      this.maxAuditStage = maxAuditStage
    }).catch(console.error)
    this.$eventBus.on(ORG_SELECT_CHANGED, this.onOrgSelectChanged)
  },
  beforeDestroy () {
    this.$eventBus.off(ORG_SELECT_CHANGED, this.onOrgSelectChanged)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/02Org/UserListEditor.vue